import { Bars3Icon } from '@heroicons/react/24/outline';
import React, { useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import MiniLogo from '../assets/logo-small.svg';
import Logo from '../assets/logo.svg';
import { Header } from '../components/headers/Header';
import { VerticalNavigation } from '../components/ui/VerticalNavigation/VerticalNavigation';
import { NavigationItem } from '../components/ui/VerticalNavigation/VerticalNavigation.types';
import { navigationItems } from '../constants/Navigation.constants';
import { PATHS } from '../constants/Paths.constants';

export type AppLayoutProps = {
  children: React.ReactNode;
};

export function AppLayout({ children }: AppLayoutProps) {
  const navigate = useNavigate();
  const location = useLocation();
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  const handleNavigationClick = (item: NavigationItem) => {
    navigate(item.href);
    setIsMobileMenuOpen(false);
  };

  const activeNavigationItems = navigationItems
    .map((item: NavigationItem) => ({
      ...item,
      current: (() => {
        // Get the first segment after "/" for both current path and item.href
        const getFirstSegment = (path: string) => {
          const parts = path.split('/').filter(Boolean);
          return parts[0] || '';
        };
        return getFirstSegment(location.pathname) === getFirstSegment(item.href);
      })()
    }));

  return (
    <div className="flex h-screen bg-gray-100">
      <VerticalNavigation
        navigationItems={activeNavigationItems}
        logoSrc={Logo}
        logoAlt="ComplAI"
        miniLogoSrc={MiniLogo}
        onItemClick={handleNavigationClick}
        isMobileMenuOpen={isMobileMenuOpen}
        onMobileMenuClose={() => setIsMobileMenuOpen(false)}
      />

      <div className="flex-1 flex flex-col lg:ml-[100px] 2xl:ml-64">
        <div className="lg:hidden bg-white border-b border-gray-200 px-4 py-3 flex items-center justify-between">
          <button
            onClick={() => setIsMobileMenuOpen(true)}
            className="p-2 rounded-md text-gray-400 hover:text-gray-500 hover:bg-gray-100"
          >
            <Bars3Icon className="h-6 w-6" />
          </button>
          <div className="w-10" />
        </div>
        <div className="hidden lg:block">
          <Header />
        </div>
        {children}
      </div>
    </div>
  );
}
